import { render, staticRenderFns } from "./BasePrimaryButton.vue?vue&type=template&id=fd653e8e&scoped=true"
import script from "./BasePrimaryButton.vue?vue&type=script&lang=js"
export * from "./BasePrimaryButton.vue?vue&type=script&lang=js"
import style0 from "./BasePrimaryButton.vue?vue&type=style&index=0&id=fd653e8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd653e8e",
  null
  
)

export default component.exports